var _rect, _rect2, _rect3, _rect4, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFavicon = function SvgIconFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 512 512"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#00C499",
    rx: 110
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "url(#Icon_Favicon_svg__a)",
    rx: 110
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "url(#Icon_Favicon_svg__b)",
    rx: 110
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "url(#Icon_Favicon_svg__c)",
    rx: 110
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#01F6C1",
    d: "M261.293 452.913q-68.271 0-110.942-30.951-40.375-29.288-50.8-81.053c-.657-3.268 1.598-6.374 4.893-6.887l72.507-11.284c3.097-.482 6.019 1.511 6.935 4.509q7.248 23.724 27.227 37.97 22.19 15.819 55.984 15.819 29.698 0 45.742-11.692 16.386-12.037 16.385-32.672 0-12.724-6.144-20.29-5.804-7.911-25.944-15.132-20.14-7.222-61.786-18.228-46.425-12.38-73.734-26.481-27.31-14.444-39.257-34.046-11.947-19.603-11.947-47.46 0-34.734 18.092-60.528 18.092-25.792 50.521-39.55 32.43-14.1 76.465-14.1 43.012 0 76.124 13.413 33.454 13.413 53.935 38.174 18.71 22.617 24.316 52.41c.597 3.174-1.573 6.164-4.751 6.737l-72.074 12.987c-3.376.609-6.543-1.744-7.31-5.088q-4.448-19.374-20.401-31.28-18.092-13.756-48.473-15.476-29.016-1.719-46.767 8.942-17.751 10.317-17.751 29.232 0 10.661 7.169 18.227t28.674 15.132q21.848 7.567 64.859 18.571 44.035 11.35 70.321 26.137 26.625 14.445 38.232 34.735 11.948 20.29 11.948 49.179 0 56.057-40.622 88.041-40.28 31.983-111.626 31.983"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_Favicon_svg__a",
    x1: 333.874,
    x2: 66.428,
    y1: 150.377,
    y2: 415.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#B970FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B970FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_Favicon_svg__b",
    x1: 446.657,
    x2: 232.727,
    y1: 19.692,
    y2: 287.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#007BA7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Icon_Favicon_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-151.907 249.666 182.453)scale(435.284 759.495)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A33DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#8A33DE",
    stopOpacity: 0
  })))));
};
export default SvgIconFavicon;